'use client';

import { LoadingSpinnerIcon } from '@/assets/icons/LoadingSpinner';
import { Button } from '@/components/ui/Button';
import { cn } from '@/lib/ui/cn';
import clsx from 'clsx';
import { useCallback, useState } from 'react';

import './BlogCategorySeeMoreButton.scss';

const DEBOUNCE_MS = 500;

type Props = {
  className?: string;
  onClick?: () => void;
};

enum Mode {
  Resting = 'resting',
  Loading = 'loading',
}

export const BlogCategorySeeMoreButton: React.FC<Props> = ({
  className,
  onClick,
}) => {
  const [mode, setMode] = useState(Mode.Resting);

  const handleClick = useCallback(() => {
    setMode(Mode.Loading);

    setTimeout(() => {
      onClick?.();

      setMode(Mode.Resting);
    }, DEBOUNCE_MS);
  }, [onClick]);

  return (
    <Button
      className={cn('BlogCategorySeeMoreButton', className)}
      disabled={mode === Mode.Loading}
      onClick={handleClick}
      variant='ghost'
    >
      <p className={clsx({ invisible: mode === Mode.Loading })}>See More</p>

      {mode === Mode.Loading && (
        <div className='BlogCategorySeeMoreButton__loading'>
          <LoadingSpinnerIcon />
        </div>
      )}
    </Button>
  );
};
